import { buildGumletUrl, GumletImageParams } from '@/utils/gumlet';

/**
 * Picks the first image from a list (or the local fallback) and runs it through
 * Gumlet for resizing/format negotiation.
 *
 * Always pass a `width` (and ideally `quality`) sized to the actual rendered
 * box. Without it, Gumlet returns the original – often 1–4 MB – which is the
 * single biggest source of "Improve image delivery" warnings in Lighthouse.
 */
export const selectMainImage = (images: string[], params?: GumletImageParams) => {
  const src = images && images.length > 0 && images[0] ? images[0] : '/imgs/image-not-found.png';
  return buildGumletUrl(src, params);
};
